// #region imports

// --- Angular
import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { LanguagesBaseService } from 'src/app/core/services';
import { LanguageModel, Constants } from 'src/app/models';
import { TranslateService } from '@ngx-translate/core';

// #endregion

@Component({
  selector: 'hs-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnDestroy, OnChanges {

  @Input() cardStyle: boolean = false;
  @Input() caption: string | undefined;
  @Input() progress: number = 0;

  selectedLanguage: LanguageModel;
  completedMessage : string = '';

  private languageSubscription: Subscription = Subscription.EMPTY;

  constructor(
    private languageService: LanguagesBaseService,
    private decimalPipe: DecimalPipe,
    private translate: TranslateService) {
      this.selectedLanguage = Constants.DEFAULT_LANGUAGE;
    }

  ngOnInit() {
    this.languageSubscription = this.languageService.selectedLanguage$.subscribe(lang => {
      this.selectedLanguage = lang;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['progress'] && changes['progress'].currentValue) {
      if (this.selectedLanguage.isoTwoLetterName === Constants.FRENCH_LANGUAGE_ISO_TWO_LETTER_CODE) {
      this.completedMessage =
        this.translate.instant('commonTextCompleted') +
        ' à ' +
        this.decimalPipe.transform(this.progress, '1.0-0') + ' %';
      } else {
        this.completedMessage =
         this.decimalPipe.transform(this.progress, '1.0-0') +
         '% ' + this.translate.instant('commonTextCompleted');
      }
    }
  }

  ngOnDestroy(): void {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
      this.languageSubscription = Subscription.EMPTY;
    }
  }

}
